import { Injectable } from '@angular/core';
import { MenuItem, MenuSection } from '@app/core/models/menu-item.model';
import { MenuRegistryService } from '@app/core/services/menu-registry.service';

import {
  AppActions,
  AppFeature,
  getClaimString,
} from '../../shared/constants/app-claims';

const menuItems: MenuItem[] = [
  {
    id: 'users',
    name: 'Usuarios',
    type: 'settings',
    dataSource: { url: 'settings/users' },
    icon: 'person',
    order: 1,
    neededClaim: getClaimString(AppFeature.SettingsUsers, AppActions.Read),
  },
  {
    id: 'roles',
    name: 'Roles',
    type: 'settings',
    dataSource: { url: 'settings/roles' },
    icon: 'security',
    order: 2,
    neededClaim: getClaimString(AppFeature.SettingsRoles, AppActions.Read),
  },
];

const menuSection: MenuSection = {
  id: 'settings',
  name: 'Configuración',
  items: menuItems,
  order: 5,
  neededClaim: getClaimString(AppFeature.Settings, AppActions.Read),
};

@Injectable({
  providedIn: 'root',
})
export class SettingsModule {
  constructor(private menuRegistry: MenuRegistryService) {
    this.menuRegistry.registerModule(menuSection);
  }
}
